<template>
  <div>
    <div><label>{{fieldData.field_label}}<span v-if="fieldData.field_required" class='star'>*</span></label></div>
      <b-form-group :id="fieldData.field_section" class="mb-0" :label-for="fieldData.field_name" >
        <input type="text"
        :id="fieldData.field_id"
        :name="fieldData.field_name"
        @keypress="numberOnly($event)"
        :class="fieldData.field_class"
        v-model="fieldData.field_model"
        v-validate="{required: fieldData.field_required, min_value: fieldData.field_min_value, max_value:fieldData.field_max_value }"
        :maxlength="fieldData.field_maxlength">
        <!-- This will only be shown if the preceding input has an invalid state -->
        <b-form-invalid-feedback
        :force-show="true"
        v-show="errors.has(fieldData.field_name)">
        {{ errors.first(fieldData.field_name) }}
        </b-form-invalid-feedback>
        </b-form-group>
        <div class="mb-1 smaller-font-content">{{fieldData.field_subtext}}</div>
    </div>
</template>

<script>
// import { mask } from 'vue-the-mask';
// import FieldIcon from '../presentational/FieldIcon';
// import { inputFieldMixin } from '../../mixins/inputFieldMixin';

export default {
  inject: ['$validator'], // Allows this component's validation messages to appear in other components
  props: ['fieldData'],
  data() {
    return {
      // field_rules: { required: false }, // Default rule for input validation
      // phone_masked_input: '', // Holds the phone masked input value outside of the computed property to avoid an infinite loop
    };
  },
  // components: { FieldIcon },
  // mixins: [inputFieldMixin],
  computed: {
  },
  methods: {
    numberOnly(evt = window.event) {
      if (/\D/g.test(evt.key)) {
        // Filter non-digits from input value.
        // this.fieldData.field_model = this.fieldData.field_model, evt.key.replace(/\D/g, '');
        evt.preventDefault();
        return false;
      }
      return true;
    },
  },
  mounted() {
  },
};
</script>

<style scoped>
#agency_section10 .form-control{
  width: 10% !important;
}
</style>



// WEBPACK FOOTER //
// src/components/admin/interactive/InputNumberCustom.vue?f1bf872a